import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { Colors } from "@/theme";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: Colors.TABLE_HEADER1,
    color: Colors.GRAY_DARK,
    fontSize: 12,
  },
}));

const TableHeaderComponent = ({ products }) => {
  const { t } = useTranslation();
  const CELL_WIDTH_IN_PERCENT = 80 / products.length;

  const [headerCells, setHeaderCells] = useState([
    {
      id: "date_time",
      label: t("dashboard_screen.date"),
      width: "20%",
      align: "left",
    },
  ]);

  useEffect(() => {
    const cells = [...headerCells];
    products.forEach((product) => {
      cells.push({
        id: `${product.id}`,
        label: product.product_code,
        width: `${CELL_WIDTH_IN_PERCENT * 0.3}%`,
        align: "left",
      });
      cells.push({
        id: `${product.id}-mtd`,
        label: `${product.product_code} MTD`,
        width: `${CELL_WIDTH_IN_PERCENT * 0.7}%`,
        align: "left",
      });
    });
    setHeaderCells(cells);
  }, []);

  return (
    <TableHead>
      <TableRow>
        {headerCells.map((cell) => (
          <StyledTableCell
            key={cell.id}
            sx={{ width: cell.width }}
            align={cell.align}
          >
            {cell.label}
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default TableHeaderComponent;
